import { Brain } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface CopilotMiniFabProps {
  onClick: () => void;
  hasMessages: boolean;
}

export function CopilotMiniFab({ onClick, hasMessages }: CopilotMiniFabProps) {
  return (
    <Button
      onClick={onClick}
      size="icon"
      className={cn(
        "fixed bottom-24 right-2 md:bottom-8 md:right-8 z-[60]",
        "h-10 w-10 md:h-12 md:w-12 rounded-full shadow-lg",
        "bg-gradient-to-br from-[hsl(var(--sg7-surface-1))] to-[hsl(var(--sg7-surface-2))]",
        "border border-[hsl(var(--sg7-stroke-subtle))]",
        "ring-2 ring-[hsl(var(--sg7-gold))/50]",
        "hover:ring-[hsl(var(--sg7-gold))] hover:scale-105",
        "transition-all duration-200"
      )}
      title="Expandir Copilot"
    >
      <Brain className={cn(
        "h-4 w-4 md:h-5 md:w-5 text-[hsl(var(--sg7-gold))]",
        hasMessages && "animate-pulse"
      )} />
      {hasMessages && (
        <span className="absolute -top-0.5 -right-0.5 flex gap-0.5 p-1 bg-[hsl(var(--sg7-surface-1))] rounded-full">
          <span className="w-1 h-1 bg-[hsl(var(--sg7-gold))] rounded-full animate-pulse" />
          <span className="w-1 h-1 bg-[hsl(var(--sg7-gold))] rounded-full animate-pulse [animation-delay:0.15s]" />
          <span className="w-1 h-1 bg-[hsl(var(--sg7-gold))] rounded-full animate-pulse [animation-delay:0.3s]" />
        </span>
      )}
    </Button>
  );
}
